import { TokenAdmService } from './../../services/token-adm.service';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LinkService } from 'src/app/services/link.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.css']
})
export class LinksComponent implements OnInit {

  links:any
  ruta:string;
  hayLinks:boolean;
  loading:boolean;
  isAdmin:boolean;
  isContribuidor:boolean;
  @Input() preguntaId: number;
  @Input() respuestaId: number;


  constructor(private router:Router, private linkService:LinkService,
              private tokenService:TokenAdmService) {}

  ngOnInit(): void {
    this.loading = true;
      this.linkService.getLinksActivosByPreguntaPublic(this.preguntaId)
      .subscribe(
        resp => {
          this.links = resp;
          if (this.links === null || this.links === undefined || this.links.length ==0)
          {
              this.hayLinks = false;
          }
          else{
            this.hayLinks = true;
          }
          this.loading = false;
        },
        error => {
          console.error(error);
          this.hayLinks = false;
          this.loading = false;
        }
      )
      this.isAdmin = this.tokenService.hasRole('Help_Admin')
      this.isContribuidor = this.tokenService.hasRole('Help_Contribuidor')
  }

  aviso(tipo:string, destino:string){
    if (tipo=='externo' || !destino.includes('uade.edu.ar'))
    {
      Swal.fire({
        title: 'Enlace externo a UADE',
        html: '<p align="left">Estas a punto de abrir un enlace a un sitio externo a UADE.<br> UADE no es responsable por el contenido del mismo.</p>',
        icon:'warning',
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: `Cancelar`,
        confirmButtonColor: 'green',
        cancelButtonColor: 'red',
      }).then((result) => {
         if (result.isConfirmed) {
          window.open(destino,'_blank', 'noreferrer,noopener' )
        }
      })
    }
    else {
      window.open(destino,'_blank', 'noreferrer,noopener' )
    }
  }

  nuevoLink(){
    sessionStorage.setItem('origenLink',location.pathname)
    this.ruta = 'help/link/0'
    this.router.navigateByUrl(this.ruta);
  }

  editarLink(linkId:number){
    sessionStorage.setItem('origenLink',location.pathname)
    this.ruta = 'help/link/'+linkId;
    this.router.navigateByUrl(this.ruta);
  }


  borrarLink(linkId:number, nombre:string) {
    Swal.fire({
      title: 'Eliminar link',
      html: `¿Estas seguro que deseas borrar el siguiente link?<br>${nombre}`,
      showDenyButton: true,
      confirmButtonText: `Si`,
      denyButtonText: `No`,
      icon:'question',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Espera por favor',
          text: 'Guardando la información',
          allowOutsideClick: false,
          timerProgressBar: true,
         });
         let timerInterval
          Swal.showLoading();
            this.linkService.eliminarLink(linkId)
            .subscribe({
              next: data => {
                Swal.fire({
                  title: 'Link Eliminado',
                  text: `El link "${nombre}" ha sido borrado con exito`,
                  icon: 'success',
                  timer: 1500,
                  timerProgressBar: true,
                  willClose: () => {
                    clearInterval(timerInterval)
                    this.ngOnInit();
                  },
                  didOpen: () => {
                    Swal.showLoading()
                    const b = Swal.getHtmlContainer().querySelector('b')
                    timerInterval = setInterval(() => {
                      if (b){
                        b.textContent = Swal.getTimerLeft()?.toString()
                      }
                    }, 100)
                  }
                    }).then(resp => {
                  if (resp.isConfirmed) {
                    this.ngOnInit();
                  }})
              },
              error: error => {
                console.error(error.error);
                Swal.fire({
                  title: 'No se pudo eliminar el lin k',
                  text: `Ocurrió un error al eliminar el link ${nombre}`,
                  icon: 'error',
                  confirmButtonText: 'Ok'
                })
              }
          });
        }

      })
  }




}
